import { LoadingOutlined } from "@ant-design/icons";
import React from "react";

const NextIcon = (props) => {
	return props.loading ? (
		<div
			style={{
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				width: "44px",
				height: "44px",
				borderRadius: "50%",
				border: "1px solid #A0A3BD",
			}}>
			<LoadingOutlined
				spin
				style={{ fontSize: "24px", color: "#A0A3BD" }}
			/>
		</div>
	) : (
		<svg
			width="44"
			height="44"
			viewBox="0 0 44 44"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<rect
				x="43.5"
				y="43.5"
				width="43"
				height="43"
				rx="21.5"
				transform="rotate(-180 43.5 43.5)"
				stroke="#A0A3BD"
			/>
			<path
				d="M19.332 28.668L26.1029 23.0256C26.7426 22.4925 26.7426 21.5101 26.1029 20.977L19.332 15.3346"
				stroke="#A0A3BD"
				stroke-width="2"
				stroke-linecap="round"
			/>
		</svg>
	);
};

export default NextIcon;
